import { FC } from 'react';
import { InstalmentDetails } from '@commerce-payment-webcomponents/ui';
import type { InstallmentDetailsPropTypes } from './types/propsTypes';
import styles from './InstallmentDetails.module.scss';

const InstallmentDetails: FC<InstallmentDetailsPropTypes> = ({
  productId,
  isAlertLink,
}: InstallmentDetailsPropTypes): JSX.Element => (
  <div className={`${styles['cpw-installment-details']}`}>
    <InstalmentDetails productId={productId} isAlertLink={isAlertLink} />
  </div>
);

export default InstallmentDetails;
export type { InstallmentDetailsPropTypes };
